

const { default: RHFAutocomplete } = require("../components/RHFAutocomplete");
const { default: RHFDatePicker } = require("../components/RHFDatePicker");
const { default: RHFDropdown } = require("../components/RHFDropdown");
const { default: RHFMultiselectDropdown } = require("../components/RHFMultiselectDropdown");
const { default: RHFTextField } = require("../components/RHFTextField");
const { default: RHFFileUpload } = require("../components/RHFFileUpload");
const { default: RHFCheckbox } = require("../components/RHFCheckbox");
const { default: RHFRadioButton } = require("../components/RHFRadioGroup");


export const renderControls = (field, index, control, getDataFunc, reset, values, isDisabled) => {
    // Use field.ValueExpr as stable key to prevent remounting when array indices shift
    const stableKey = field?.ValueExpr || index;

    switch (field.DataType) {
        case "Textbox":
            return <RHFTextField key={`${stableKey}${reset || ''}`} formData={field} control={control} values={values} isDisabled={isDisabled} />;
        case "MultiselectDropdown":
            return (
                <RHFMultiselectDropdown
                    key={`${stableKey}${reset || ''}`}
                    formData={field}
                    control={control}
                />
            );
        case "Dropdown":
            return <RHFDropdown key={`${stableKey}${reset || ''}`} formData={field} control={control} values={values} />;
        case "Autocomplete":
            return <RHFAutocomplete key={`${stableKey}${reset || ''}`} formData={field} control={control} getDataFunc={getDataFunc} values={values} />;
        case "Date":
            return <RHFDatePicker key={`${stableKey}${reset || ''}`} formData={field} control={control} values={values} isDisabled={isDisabled} />;
        case "UploadFile":
        case "File":
            return <RHFFileUpload key={`${stableKey}${reset || ''}`} formData={field} control={control} values={values} />;
        case 'CheckBox':
            return <RHFCheckbox key={`${stableKey}${reset || ''}`} formData={field} control={control} values={values} />;
        case 'RadioButton':
            return <RHFRadioButton key={`${stableKey}${reset || ''}`} formData={field} control={control} values={values} />;
        default:
            return null;
    }
};
